import Skeleton from "react-loading-skeleton";
import { JSX } from "react";

export const CheckoutBackLinkSkeleton = (): JSX.Element => (
    <Skeleton
        containerClassName="p-checkout-page__back--skeleton"
        width={80}
        height={15}
        borderRadius={4}
    />
);

export const CheckoutOrderSummarySkeleton = (): JSX.Element => (
    <div className="p-checkout-page__order-summary-skeleton">
        <div className="p-checkout-page__order-summary-skeleton__section">
            <Skeleton height="2.7rem" width="55%" borderRadius={4} />
        </div>
        <div className="p-checkout-page__order-summary-skeleton__section">
            <Skeleton height="2.7rem" count={2} borderRadius={4} />
        </div>
        <div className="p-checkout-page__order-summary-skeleton__section p-checkout-page__order-summary-skeleton__section--footer">
            <Skeleton height="2.7rem" borderRadius={4} />
            <Skeleton height="4rem" borderRadius={8} />
        </div>
    </div>
);
